import _ from 'lodash'
import BaseUIProductBundlesDetailView from 'xui/modules/order/BaseUIProductBundlesDetailView'

import * as NavActions from 'x/utils/navigation'
import * as util from 'x/utils/util'

export default class ProductBundlesDetailView extends BaseUIProductBundlesDetailView {
  static displayName = 'ProductBundlesDetailView'
}
